import axios from 'axios';

export const cataloguesApi = axios.create({
    baseURL: `${process.env.REACT_APP_BACKEND!}api/catalogue`,
    headers: {
        'Content-Type': 'application/json'
    }
})